import Ajax from "Utils/ajax";
export const leaveType = () => Ajax.post('hr/leaveType'); 
export const getAllStaffByHRorManager = (data) => Ajax.post('hr/getAllStaffByHRorManager',data); 
export const leaveBalance = (data) => Ajax.post('hr/leaveBalance',data);